var borders_default = {
  "borderT": "UKWLG",
  "borderB": "_8sDOa",
  "borderL": "-fwlB",
  "borderR": "_0e8jR",
  "borderColorOverride": "boE9N"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
